/**
 * Initial loading screen shown while auth state is being resolved.
 * Calm and uses the same design language so the transition is invisible
 * on fast networks.
 */
export function Splash() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-bg text-ink">
      <span
        className="size-9 animate-spin rounded-full border-[2.5px] border-line"
        style={{ borderTopColor: 'var(--color-accent)' }}
      />
      <span className="font-serif text-xl tracking-tight">BabyNook</span>
    </div>
  );
}
